import { render, staticRenderFns } from "./ProfileBadge.vue?vue&type=template&id=7f6e6f38&"
import script from "./ProfileBadge.vue?vue&type=script&lang=js&"
export * from "./ProfileBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports